<button [matMenuTriggerFor]="menu">
  {{ text }}
  <svg
    class="w-2.5 h-2.5 ms-1 inline"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 10 6"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="m1 1 4 4 4-4"
    />
  </svg>
</button>
<mat-menu #menu="matMenu" yPosition="below">
  <ng-content></ng-content>
</mat-menu>
